import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ManifestoService {

  constructor(private http: HttpClient) { }

  getArrayParameterUri(parameter, name) {
    let finalSubstring = '';
    if (parameter && parameter.length > 0) {
      parameter.forEach(element => {
        finalSubstring += `${element ? `&${name}=${element}` : ''}`
      });
      return finalSubstring;
    }
    return '';
  }

  getAllManifestos(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `Manifesto/Painel? ${req.numeroCompletoManifesto ? `&numeroCompletoManifesto=${req.numeroCompletoManifesto}` : ''}
        ${req.dataInicial ? `&dataInicial=${req.dataInicial}` : ''}
        ${req.dataFinal ? `&dataFinal=${req.dataFinal}` : ''}
        ${this.getArrayParameterUri(req.regionalIds, 'regionalIds')}
        ${this.getArrayParameterUri(req.agenteIds, 'agenteIds')}
        ${req.necessarioME ? `&necessarioME=${req.necessarioME}` : ''}
        ${req.tipoManifesto ? `&tipoManifesto=${req.tipoManifesto}` : ''}
        ${req.codigoBarras? `&codigoBarras=${req.codigoBarras}` : ''}
        ${req.ordenacao ? `&ordenacao=${req.ordenacao}` : ''}
        ${req.paginaAtual ? `&paginaAtual=${(req.paginaAtual || 0) + 1}` : ''}
        ${req.itensPorPagina ? `&itensPorPagina=${req.itensPorPagina}` : ''}
        ${req.tipoSituacaoManifestoId ? `&tipoSituacaoManifestoId=${req.tipoSituacaoManifestoId}` : ''}
        ${req.tipoSituacaoVisualizacaoId ? `&tipoSituacaoVisualizacaoId=${req.tipoSituacaoVisualizacaoId}` : ''}`,
        { observe: 'response' }
      );
  }

  getManifestoPainelCards(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `Manifesto/Painel/Cards? ${req.numeroCompletoManifesto ? `&numeroCompletoManifesto=${req.numeroCompletoManifesto}` : ''}
        ${req.dataInicial ? `&dataInicial=${req.dataInicial}` : ''}
        ${req.dataFinal ? `&dataFinal=${req.dataFinal}` : ''}
        ${this.getArrayParameterUri(req.regionalIds, 'regionalIds')}
        ${this.getArrayParameterUri(req.agenteIds, 'agenteIds')}
        ${req.necessarioME ? `&necessarioME=${req.necessarioME}` : ''}
        ${req.tipoManifesto ? `&tipoManifesto=${req.tipoManifesto}` : ''}
        ${req.tipoSituacaoVisualizacaoId ? `&tipoSituacaoVisualizacaoId=${req.tipoSituacaoVisualizacaoId}` : ''}
        ${req.codigoBarras? `&codigoBarras=${req.codigoBarras}` : ''}`,
        { observe: 'response' }
      );
  }

  getManifestoParametro(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `Manifesto/Parametro?chave=${req.chave}&agenteId=${req.agenteId ? req.agenteId : '0'}`,
        { observe: 'response' }
      );
  }

  getDetalheContador(req: any): Observable<HttpResponse<any>> {
    return this.http
      .get(`Manifesto/Detalhe/Contador?manifestoId=${req.manifestoId}&isDevolucao=${req.isDevolucao}`,
        { observe: 'response' });
  }

  getManifestoDetalhes(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `Manifesto/Detalhe?ManifestoId=${req.manifestoId}&isDevolucao=${req.isDevolucao}&FiltroDataRecepcao=${req.dataRecepcao}&FiltroRessalva=${req.ressalva}
        ${req.codigoBarras ? `&codigoBarras=${req.codigoBarras}`: ''}
          ${req.paginaAtual ? `&PaginaAtual=${(req.paginaAtual || 0) + 1}` : '&PaginaAtual=1'}
          ${req.itensPorPagina ? `&ItensPorPagina=${req.itensPorPagina}` : '&PaginaAtual=10'}`,          
        { observe: 'response' }
      );
  };

  createRessalva(objectRequest: any): Observable<any> {
    return this.http.post(
      `Manifesto/Ressalva`,
      objectRequest,
      { observe: 'response' }
    );
  }

  baixarManifesto(objectRequest: any): Observable<any> {
    return this.http.post(
      `Manifesto/Baixar`,
      objectRequest,
      { observe: 'response' }
    );
  }

  salvarJustificativaAprovacao(objectRequest: any): Observable<any> {
    return this.http.post(
        `Manifesto/SalvaSolicitacao`,
        objectRequest,
        { observe: 'response' }
      );
  } 

}
